<template>
<div>
    <!--<h1>our impact</h1>-->
    <section class="intro bg-grey center-div" style="height: 460px; background-size: cover; background-image: url('/assets/images/services/CitSci_20220921_0803-X3.png');">
        <div class='intro-description text-white' data-aos="zoom-in" data-aos-duration="1500" data-aos-delay='250'>
        <div class="container">
            <!--Our impact is made possible-->
            <br/>
            <p class="intro-description-text text-white font-weight-black text-center" style="font-size: 60px">Services</p>
        </div>
        </div>
        <!--<img  data-aos="fade-left" data-aos-delay='1500' class='introImage' src='https://res.cloudinary.com/dsderm9xw/image/upload/v1622028117/3D%20Illustrations/3d-illustration4_usckww.png' alt='3d illustration of boy with a flag'/>-->
    </section>

    <div class="container" data-aos="fade-up">
        <div data-aos="fade-up">
            <h1 class="font-weight-bold text-left">What is CitSci</h1>
            <p>CitSci is a collaborative platform and community for citizen science. We help individuals, nonprofits, agencies,
            and researchers design, run, and grow participatory science projects. Whether you need a place to collect and
            analyze data, a custom hub for multiple projects, or help writing research questions, CitSci offers both free tools
            and tailored professional services.
            </p>
        </div>
        <div data-aos="fade-up">
            <h1 class="font-weight-bold text-left">What We Offer</h1>
            <h3>Free tools</h3>
            <p>Every CitSci account includes access to our powerful, easy-to-use tools-free of charge:</p>
            <p>
                <ul>
                    <li>Host unlimited participatory science projects</li>
                    <li>Use our datasheet creator</li>
                    <li>Visualize data in maps and graphs</li>
                    <li>Manage and communicate with volunteers</li>
                    <li>Export your citizen science data anytime</li>
                </ul>
            </p>
            <br/>
        </div>
        <div data-aos="fade-up">
            <hr>
            <h1 class="font-weight-bold text-left">Paid Services (Optional Add-Ons)</h1>
            <p>For projects that need something extra, we offer optional services to help you scale, customize, or professionalize your efforts.</p>

            <h3>Technical Services</h3>
            <div class="ml-5">
                <p>Need tools, tech, or infrastructure? We’ve got you covered.</p>

                <h4> API Integrations</h4>
                <p>Seamlessly connect CitSci with other systems or platforms. Basically, “API” is a fancy term meaning we can
                    get our websites to talk to each other, and send information - like project descriptions - back and forth</p>
                <h4>Custom Hub Development</h4>
                <p>
                    A centralized dashboard to share your projects and key indicators for your community. This is a great fit if
                    your organization has multiple projects to showcase together. Check out <b-link href="/organizations/leave-no-trace-center-for-outdoor-ethics/">
                    this example</b-link> from Leave No Trace.
                </p>
            </div>

            <h3>Programmatic Services</h3>
            <div class="ml-5">
                <p>Need help planning or running your citizen science project? We can help.</p>

                <h4>Project Design Consultation</h4>
                <p>From forming your research question to choosing the right data collection methods.</p>

                <h4>Training & Webinars</h4>
                <p>Virtual or in-person sessions for your team or participants.</p>

                <h4>Workshop Facilitation</h4>
                <p>Including customized educator sessions for professional development.</p>

                <h4>Protocol or Datasheet Design</h4>
                <p>Make your materials beautiful and easy to follow. We make printables for your project that folks can take into the field!</p>

                <h4>Outreach Strategy & Content Creation</h4>
                <p>Build awareness, understand your stakeholders, and engage participants</p>
                <br/>
            </div>
        </div>
        <div data-aos="fade-up">
            <hr>
            <h1 class="font-weight-bold text-left">What Our Partners Say</h1>
            <blockquote class="blockquote w-75">
                <div class="float-left text-muted position-relative" style="top: -44px; left: -10px; font-size: 60px; font-family: Georgia, serif; font-weight: normal;">
                    “
                </div>
                <p class="ml-4">
                CitSci is an essential partner for our projects, allowing us to engage the broader community for both
                our education mission and scientific research deliverables, as well as to help us exceed the expectations
                of our research sponsors - we were specifically asked to continue CitSci activities in follow-on projects.
                On just one of our projects over 6 months, CitSci has allowed us to engage with hundreds of volunteers and
                collect samples across the country, all of which would not have been possible without their efforts above
                and beyond the call of duty.</p>
                <footer class="blockquote-footer ml-4">Dr. James Henrickson,
                    <cite title="Source Title">Research Scientist, <b-link href='/projects/the-extremophile-campaign-in-your-home/'>Extremophile Campaign</b-link></cite>
                </footer>
            </blockquote>

            <blockquote class="blockquote w-75">
                <div class="float-left text-muted position-relative" style="top: -44px; left: -10px; font-size: 60px; font-family: Georgia, serif; font-weight: normal;">
                    “
                </div>
                <p>
                    With CitSci's facilitation support, we were able to reach 25+ universities for our Leave No Trash University Challenge.
                </p>
                <footer class="blockquote-footer ml-4">Elise Robinson, <cite title="Source Title">Manager of Training and Programs,
                    <b-link href='/projects/leave-no-trash-university-challenge'>Leave No Trash University Challenge</b-link></cite>
                </footer>
            </blockquote>
            <br/>

        </div>
        <div data-aos="fade-up">
            <hr>
            <h1 class="font-weight-bold text-left">Ready To Chat?</h1>
            <p>Whether you need tech customization or program guidance, we're happy to help.</p>
            <p>
                <b-link :to="{name: 'Contact'}">
                Contact Us</b-link> to schedule a free 30-minute consultation.
            </p>
            <p>We'll help you figure out what tools and services are the best fit for your goals.</p>
            <br/>
        </div>
        <div data-aos="fade-up">
            <hr>
            <h1 class="font-weight-bold text-left">Pricing Information</h1>
            <p>We work with groups of all sizes and budgets. During your consultation, we'll start scoping what's feasible and work with you to provide a clear quote.</p>
            <br/>
        </div>
        <div data-aos="fade-up">
            <hr>
            <h1 class="font-weight-bold text-left">Want to Share or Save this Info?</h1>
            <p>Access <b-link href='/assets/images/services/onepager.pdf' target="NewWindow">our one-pager</b-link> as a PDF!
                Perfect for sharing with colleagues, funders, or partners.
            </p>
            <p>Need a customized version for your organization or event? <b-link @click="openCitSciHelp()">Just reach out</b-link> -we're happy to help.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "ServicesShow",
  data() {
    return {
        supportFormURL: 'https://docs.google.com/forms/d/e/1FAIpQLSc_K0CvacZRItpra4_O5npwjZZTYzAPHPidUxr4rVrDUf9EVg/viewform',
    };
  },
  methods: {
    openCitSciHelp() {
      let supportForm = this.supportFormURL + '?usp=pp_url&entry.630403450=https://citsci.org' + this.$route.fullPath
      window.open(supportForm, "_blank")
    },
  },
};
</script>

<style lang="scss" scoped>
hr {
  border-color:grey;
}
</style>
